import type { DocgenResponse } from "@/api/schemas";

/**
 * Lightweight fixture for the ``?demo=1`` deep link — lets the docgen
 * view be exercised end-to-end without first walking through Steps
 * 1–2. Numbers are illustrative; replace with a real generated payload
 * during integration testing.
 */
export const DEMO_DOCGEN: DocgenResponse = {
  status: "ok",
  elapsed_seconds: 12.4,
  validation: {
    is_valid: true,
    errors: [],
    warnings: [
      {
        section_id: "tlocrtna_dispozicija",
        message: "Visina V_max prelazi indikativnu vrijednost iz GUP-a (8.50 > 8.00).",
      },
    ],
  },
  fact_sheet: {
    _sources: {
      bruto_total_m2: "user",
      cestica_povrsina_m2: "user",
      kig: "computed",
      kisn: "computed",
      tlocrtna_projekcija_m2: "user",
      total_glazed_area_m2: "ifc",
      openings_schedule: "ifc",
      materials_by_element: "ifc",
    },
    bruto_total_m2: 412.5,
    bruto_nadzemno_m2: 312.5,
    tlocrtna_projekcija_m2: 168.4,
    cestica_povrsina_m2: 720.0,
    kig: 0.23,
    kisn: 0.43,
    zelena_povrsina_m2: 410.0,
    zelena_pct: 0.57,
    total_glazed_area_m2: 28.6,
    compliance_checks: [
      {
        parameter: "KIG",
        actual: 0.23,
        limit: 0.4,
        check_type: "max",
        status: "OK",
      },
      {
        parameter: "Visina V (max)",
        actual: 8.5,
        limit: 8.0,
        check_type: "max",
        status: "PREKORACENO",
      },
    ],
  },
  izjave: [
    {
      section_id: "izjava_glavnog_projektanta",
      title: "Izjava glavnog projektanta",
      content:
        "Ja, ime glavnog projektanta, ovlašteni arhitekt, izjavljujem da je projekt izrađen u skladu s pravilima struke...",
      source: "template",
      facts_used: [],
    },
  ],
  naslovnice: [
    {
      section_id: "naslovnica_arh",
      title: "Naslovnica — Arhitektonski projekt",
      content:
        "PROJEKTNA DOKUMENTACIJA\nMapa 1 — Arhitektonski projekt\nInvestitor: ...",
      source: "template",
      facts_used: [],
    },
  ],
  tekstualni_dio: [
    {
      section_id: "tlocrtna_dispozicija",
      title: "Tlocrtna dispozicija",
      content:
        "Građevina je tlocrtnih dimenzija 14,2 × 11,8 m, ukupne tlocrtne projekcije 168,4 m². Otvorima je riješeno prirodno osvjetljenje svih boravišnih prostorija; ukupna ostakljena površina iznosi 28,6 m². Na sjevernoj strani parcele zadržan je zaštitni zeleni pojas širine 3,0 m...",
      source: "llm",
      facts_used: [
        "tlocrtna_projekcija_m2",
        "total_glazed_area_m2",
        "openings_schedule",
      ],
    },
    {
      section_id: "materijali_konstrukcije",
      title: "Materijali i konstrukcija",
      content:
        "Nosiva konstrukcija je armiranobetonska s vanjskim zidovima debljine 30 cm (siporeks blok + 12 cm fasadna toplinska izolacija od mineralne vune). Krov je dvostrešni s pokrovom od glinenih crepova na drvenoj rogovskoj konstrukciji...",
      source: "llm",
      facts_used: ["materials_by_element"],
    },
    {
      section_id: "instalacije_elektrika",
      title: "Elektroinstalacije",
      content:
        "Električna instalacija izvodi se prema HRN HD 60364. Predviđen je priključak [ ZA RUČNI UNOS ], brojilo u zajedničkom razdjelniku...",
      source: "placeholder",
      facts_used: [],
    },
  ],
  tables: [
    {
      section_id: "iskaz_otvora",
      title: "Iskaz otvora",
      content:
        "Oznaka  | Tip      | Š (m) | V (m) | Pov. (m²) | Materijal\n--------+----------+-------+-------+-----------+----------\nP1      | Vrata    | 1.00  | 2.10  | 2.10      | Drvo\nP2      | Prozor   | 1.20  | 1.40  | 1.68      | PVC\nP3      | Prozor   | 1.20  | 1.40  | 1.68      | PVC\n",
      source: "template",
      section_type: "table",
      facts_used: ["openings_schedule"],
    },
  ],
  mape: [],
  opci_variables: {},
};
